import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { Col, Container, Row } from "react-bootstrap";
export default function AboutContactUs() {
  const $ = _c(19);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Row><Col><h1>Contact Us</h1></Col></Row>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p>The best way to find us at:{" "}<Link href="https://x.com/6529collections" target="_blank" rel="noopener noreferrer">https://x.com/6529collections</Link></p>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p>or email us at <a href="mailto:support@6529.io">support@6529.io</a></p>;
    t3 = <br />;
    t4 = <p>Alternative, but not as good, methods to contact us are:</p>;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Link href="https://x.com/punk6529" target="_blank" rel="noopener noreferrer">punk6529</Link>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Link href="https://x.com/6529er" target="_blank" rel="noopener noreferrer">6529er</Link>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <li>Trying to get the attention of @{t5}{" "}or @{t6}{" "}or @<Link href="https://x.com/teexels" target="_blank" rel="noopener noreferrer">teexels</Link>{" "}on Twitter</li>;
    t8 = <br />;
    $[7] = t7;
    $[8] = t8;
  } else {
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Link href="https://x.com/punk6529" target="_blank" rel="noopener noreferrer">punk6529</Link>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Link href="https://x.com/6529er" target="_blank" rel="noopener noreferrer">6529er</Link>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Link href="https://x.com/teexels" target="_blank" rel="noopener noreferrer">teexels</Link>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  let t13;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <ul>{t7}{t8}<li>Trying to get the attention of @{t9}, @{t10}{" "}or @{t11}{" "}in the OM Discord (<Link href="https://discord.gg/join-om" target="_blank" rel="noopener noreferrer">https://discord.gg/join-om</Link>). We don't answer Discord DMs from people we don't already know.</li></ul>;
    t13 = <br />;
    $[12] = t12;
    $[13] = t13;
  } else {
    t12 = $[12];
    t13 = $[13];
  }
  let t14;
  let t15;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <br />;
    t15 = <br />;
    $[14] = t14;
    $[15] = t15;
  } else {
    t14 = $[14];
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <br />;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <br />;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  let t18;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Container>{t0}<Row className="pt-3 pb-3"><Col>{t1}{t2}{t3}{t4}{t12}{t13}<p>If, for some strange reason, you would like to send us a letter or postcard, you can do so here:{t14}{t15}6529 Collection LLC{t16}2810 N Church St{t17}#76435 Wilmington, DE 19802-4447<br />United States of America</p></Col></Row></Container>;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  return t18;
}